import React, { useEffect, useRef } from 'react';
import { Wand2, Gem, Truck, ShieldCheck } from 'lucide-react';
import './Services.css';

const ServicesPage = () => {
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('flip-in');
          } else {
            entry.target.classList.remove('flip-in');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px',
      }
    );

    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const services = [
    {
      icon: <Wand2 className="service-icon" />,
      title: "Bespoke Creations",
      description: "Crafting one-of-a-kind jewelry tailored to your vision.",
      image: "/assets/custom-design-icon.png",
    },
    {
      icon: <Gem className="service-icon" />,
      title: "Jewelry Revive",
      description: "Expert repairs to restore your treasured pieces.",
      image: "/assets/jewelry-repair-icon.png",
    },
    {
      icon: <Truck className="service-icon" />,
      title: "Express Delivery",
      description: "Swift and secure shipping at no extra cost.",
      image: "/assets/free-shipping-icon.png",
    },
    {
      icon: <ShieldCheck className="service-icon" />,
      title: "Forever Assurance",
      description: "A lifetime guarantee for your cherished jewelry.",
      image: "/assets/lifetime-warranty-icon.png",
    },
  ];

  return (
    <div className="services-section">
      <h2>Our Services</h2>
      <div className="services-container">
        {services.map((service, index) => (
          <div
            key={index}
            className="service-item"
            ref={(el) => (cardRefs.current[index] = el)}
          >
            {service.icon}
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
